import type { FinalRoundType } from "@/modules/boxDashboard/gateway/boxDashboardApiDto"
import { FinalRoundMemberEntity } from "@/modules/boxDashboard/modules/FinalRoundMembers/entities/finalRoundMemberEntity"
import { useServicesContext } from "@modules/core/services/services.context"
import { useQuery } from "@tanstack/react-query"

export const FINAL_ROUND_MEMBERS_QUERY_KEY = ["finalRoundMembers"]
export const FINAL_ROUND_MEMBERS_PAGE_SIZE = 10

export function useFinalRoundMembers(offerType?: FinalRoundType, page = 0, pageSize = FINAL_ROUND_MEMBERS_PAGE_SIZE) {
  const { boxDashboardApi } = useServicesContext()

  const { data, isLoading, isFetching, error, refetch } = useQuery({
    queryKey: [...FINAL_ROUND_MEMBERS_QUERY_KEY, offerType, page, pageSize],
    queryFn: async () => {
      const response = await boxDashboardApi.getFinalRoundMembers(offerType, page, pageSize)
      return {
        members: response.content.map((dto) => FinalRoundMemberEntity.fromDto(dto)),
        totalCount: response.totalElements,
        currentPage: response.page,
        totalPages: response.totalPages,
      }
    },
    staleTime: 0,
    gcTime: 0,
  })

  return {
    members: data?.members ?? [],
    totalCount: data?.totalCount ?? 0,
    totalPages: data?.totalPages ?? 0,
    currentPage: data?.currentPage ?? 0,
    hasMore: data ? data.currentPage < data.totalPages - 1 : false,
    isLoading,
    isFetching,
    error,
    refetch,
  }
}

export function useTotalFinalRound() {
  const { boxDashboardApi } = useServicesContext()

  const { data, isLoading } = useQuery({
    queryKey: ["totalFinalRound"],
    queryFn: async () => {
      return boxDashboardApi.getTotalFinalRound()
    },
  })

  return {
    total: data?.total ?? 0,
    classPassTotal: data?.classPassTotal ?? 0,
    membershipTotal: data?.membershipTotal ?? 0,
    isLoading,
  }
}
